import { render, staticRenderFns } from "./FavoritesItem.vue?vue&type=template&id=4c9abcb6"
import script from "./FavoritesItem.vue?vue&type=script&lang=js"
export * from "./FavoritesItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports